import type { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

// His viewer level (claude.ai "read only" against Contributor), per module, set in Accès. The server
// refuses every write from a read-only module (ModuleGate); this says so and greys the buttons.
export function useReadOnly(module: string) {
  const { staff } = useAuth();
  return !!staff?.read_only_modules?.includes(module);
}

// His banner: who to ask, in the module's own words.
export function ReadOnlyBanner({ module, text }: { module: string; text: string }) {
  if (!useReadOnly(module)) return null;
  return <p className="mb-3 rounded-lg bg-amber-50 px-4 py-2 text-sm text-amber-900 ring-1 ring-amber-200">{text}</p>;
}

// Everything inside is disabled for a read-only person — buttons, steppers, fields — and greyed
// (index.css). Reading, opening and the lists stay outside it.
export function ReadOnlyArea({ module, children }: { module: string; children: ReactNode }) {
  return <fieldset disabled={useReadOnly(module)} className="min-w-0">{children}</fieldset>;
}
